// import { database } from "../firebaseConfig2";
import { useEffect, useState } from 'react';
import DropdownMenu from "./dropdown-menu";

function Fans(props) {
    const [fansDisplayed, setFansDisplayed] = useState([]); //used to filter by country
    const [selectedCountry, setSelectedCountry] = useState("all"); 

    const groupedByCountry = Object.groupBy(props.fansList, item => item.country);
    
    //check for a change in country
    useEffect(() => {
        
        if (selectedCountry === "all"){
            setFansDisplayed(props.fansList);
        }
        else {
            setFansDisplayed(groupedByCountry[selectedCountry]);
        }
    }, [props.fansList, selectedCountry, groupedByCountry]); // <-- dependency array
    
  const renderFans = fansDisplayed.map(temp => 
    <div className='individual-fan-container'> 
      <div className='fan-fact'>
        <div className='fan-name'>{temp.name}</div>
        <div className='fan-links'>
            <a style={{ textDecoration: temp.email ? 'hidden': 'line-through',  color: temp.email ? 'inherited': '#4f4f4f'}} href={`mailto:${temp.email}`}>email</a> •
            <a target="_blank" rel="noopener noreferrer" href={temp.website}>website</a> •
            <p>{temp.country}</p>
        </div>
        <div className='fan-favs'>
            <p><span style={{fontWeight: 'bold'}}>Favorite Princess: </span>{temp.princess}</p>
        </div>
      </div>
    </div>
    );

  return (
    <div className="fans-list-container">
        <div className="header-bar">
            <div className="page-title">Fans</div>
            <DropdownMenu value={selectedCountry} setValue={setSelectedCountry} groups={groupedByCountry}/>

        </div>
        {renderFans}
    </div>
  );
}

export default Fans;